import * as eventTypeList from '../triggerSystem/abstractEventsHeader'
import * as conditionsHeader from '../triggerSystem/abstractConditionsHeader'
import * as actionsHeader from '../triggerSystem/abstractActions'
import * as predefTypeList from '../triggerSystem/predefined'
import * as functionTypeList from '../triggerSystem/functions'
import variablesHeader from '../triggerSystem/variablesHeader'

import { getTypeFromFixtureTypeName } from '../consts/fixtureTypes'
// TODO: Separate functions handling the state than the one handling the game

export function getFunction (functions, functionId) {
    return functions.find(({ id }) => id === functionId);
}

export function getVariable (state, _id) {
  return state.variables.find(({id}) => id == _id)
}

export function getFixture (state, _id) {
  return state.fixtures.find(({id}) => id == _id)
}

export function getVariableType (variable) {
  if(variable == 'UNDEFINED'
    || typeof variable !== 'object') {
    return 'UNDEFINED'
  }
  else
    return variable.type;
}

export function getVariableHeader(type) {
  return variablesHeader.find(f => f.type == type);
}

export function getFixtureType (fixture) {
  if(fixture == 'UNDEFINED'
    || typeof fixture !== 'object') {
    return 'UNDEFINED'
  }
  else
    return fixture.fixtureType;
}

export function getFunctionDeclaration (functionType) {
  for(var funcKey in eventTypeList) { // To optimize
    var declaration = (eventTypeList[funcKey])();
    if(declaration.type == functionType) {
      return declaration;
    }
  }
  for(var funcKey in functionTypeList) { // To optimize
    var declaration = (functionTypeList[funcKey])();
    if(declaration.type == functionType) {
      return declaration;
    }
  }
  for(var funcKey in conditionsHeader) { // To optimize
    var declaration = (conditionsHeader[funcKey])();
    if(declaration.type == functionType) {
      return declaration;
    }
  }for(var funcKey in actionsHeader) { // To optimize
    var declaration = (actionsHeader[funcKey])();
    if(declaration.type == functionType) {
      return declaration;
    }
  }
  
  return '';
}

export function getDefaultArgs (functionType) {
  var declaration = getFunctionDeclaration (functionType);
  if(typeof declaration.defaultArgs === 'object'
    && declaration.defaultArgs.length == declaration.argTypes.length) {
    return declaration.defaultArgs;
  }
  // TODO: Automatically assign a default value
  return [];
}

// Return the default value for the argument of a function
export function getDefaultValue(returnType, mode) {
  if(mode != 'VALUE')
    return 'NULL';  // TODO: Handle default value for other modes
  else {
    var variableHeader = getVariableHeader(returnType);
    if(variableHeader != null && typeof variableHeader === 'object') {
      var value = variableHeader.default;
      if(value != null && typeof value !== 'undefined') {
        return value;
      }
    }
  }
  return 'NULL';
}

export function getPredefDeclaration (predefType) {
  for(var key in predefTypeList) { // To optimize
    var declaration = (predefTypeList[key])();
    if(declaration.type == predefType) {
      return declaration;
    }
  }
  return '';
}

export function getTriggerFunction (trigger, functionId) {
    return trigger.functions.find(({ id }) => id === functionId);
}



export function getArgValue (state, declaration, func, argId) {
  if(typeof func.args[argId] === 'undefined' || func.args[argId] == null)
      return 'UNDEFINED';

  var arg = func.args[argId];

  if(typeof arg.mode === 'undefined')
    return 'UNDEFINED';
  else if (arg.mode == 'FUNCTION') 
    return 'FUNCTION';

  return arg.value;
}

// To keep up to date with accessorsEngine
export function getArgType (state, declaration, func, argId) {
  if(typeof declaration !== 'object'
    || typeof declaration.argTypes !== 'object') {
    console.log('declaration undefined', declaration)
    return 'UNDEFINED'
  }
  
  const type = declaration.argTypes[argId];
  if(type == 'ARG_0_TYPE') {
    const type0 = declaration.argTypes[0];
    switch(type0) {
      case 'VARIABLE': 
        const variableType = getVariableType(
          getVariable(state, getArgValue(state, declaration, func, 0))
        );
        return variableType != 'UNDEFINED' ? variableType : 'DISABLED';
      case 'FIXTURE_OUTPUT':
      case 'FIXTURE_DIGITAL_OUTPUT':
      case 'FIXTURE_SERVO':
        const fixtureType = getTypeFromFixtureTypeName(
          getFixtureType(
            getFixture(state, getArgValue(state, declaration, func, 0))
          )
        )
        return typeof fixtureType != 'undefined' ? fixtureType.variableType : 'DISABLED';
      default:
        logError('Unrecognized type0 '+JSON.stringify(declaration))
    }
  }
  return type;
}

export function getPredefName (state, type, ref) {
  switch (type) {
    case 'PAD_INPUT_CHECKBOX':
    case 'PAD_INPUT_BUTTON':
      var padInput = state.padInputs.find(({id}) => id == ref);
      return typeof padInput === 'object' ? 'I'+padInput.id+':'+padInput.name : 'UNDEFINED';
    case 'FIXTURE_OUTPUT':
    case 'FIXTURE_INPUT':
    case 'FIXTURE_SERVO':
      var fixture = state.fixtures.find(({id}) => id == ref);
      return typeof fixture === 'object' ? fixture.podId+'.'+fixture.dongleId+'.'+fixture.id+':'+fixture.name : 'UNDEFINED';
    case 'SFX':
      var sound = state.medias.find(({id}) => id == ref);
      return typeof sound === 'object' ? sound.name : 'UNDEFINED';
    case 'PLAYLIST':
      var playlist = state.playlists.find(({id}) => id == ref);
      return typeof playlist === 'object' ? playlist.name : 'UNDEFINED';
    case 'VIDEO':
      var video = state.medias.find(({id}) => id == ref);
      return typeof video === 'object' ? video.name : 'UNDEFINED';
    default:
      var predefDeclaration = getPredefDeclaration(ref);
      return typeof predefDeclaration === 'object' ?
        predefDeclaration.name : 'Unrecognized predefined value'
  }    
}


export function getFunctionsOfType(functionList, _triggerId, _functionType) {
  return functionList.filter(({triggerId, functionType}) => 
    triggerId == _triggerId && functionType == _functionType)
}

export function reorderFunctions(state, triggerId, functionType) {
  var list = getFunctionsOfType(state, triggerId, functionType)
  list = list.sort((a, b) => a.order-b.order);

  return state.map(func => {
    if(func.triggerId == triggerId
      && func.functionType == functionType) {
      for(var i = 0; i < list.length; i++) {
        if(list[i].id == func.id)
          return {...func, order:i}
      }
    }
    return func;
  });
}
